import { RiShareForwardLine } from "react-icons/ri";

type Props = { data: any };

const CardInfoSalon = ({ data }: Props) => {
  return (
    <div className="bg-white h-full px-3 py-4 flex items-center justify-between rounded-xl w-full gap-2">
      <div className="flex items-center flex-col gap-4 justify-between h-fit">
        <span className="text-color-primary text-base max-3xl:text-sm max-xl:text-xs  font-semibold">
          Clients
        </span>
        <span className="text-[#75757E] text-base max-3xl:text-sm max-xl:text-xs font-semibold flex items-center gap-1">
          {data?.salon?.clients_count}
          <RiShareForwardLine className="text-color-primary flex items-center" />
        </span>
      </div>
      <div className="flex items-center flex-col gap-4 justify-between h-fit">
        <span className="text-color-primary text-base  max-3xl:text-sm max-xl:text-xs font-semibold">
          Services
        </span>
        <span className="text-[#75757E] text-base max-3xl:text-sm max-xl:text-xs font-semibold flex items-center gap-1">
          {data?.services_count}
          <RiShareForwardLine className="text-color-primary flex items-center" />
        </span>
      </div>
      <div className="flex items-center flex-col gap-4 justify-between h-fit">
        <span className="text-color-primary text-base max-3xl:text-sm max-xl:text-xs  font-semibold">
          Packages
        </span>
        <span className="text-[#75757E] text-base max-3xl:text-sm max-xl:text-xs font-semibold flex items-center gap-1">
          {data?.packages_count}
          <RiShareForwardLine className="text-color-primary flex items-center" />
        </span>
      </div>
      <div className="flex items-center flex-col gap-4 justify-between h-fit">
        <span className="text-color-primary text-base max-3xl:text-sm max-xl:text-xs  font-semibold">
          Products
        </span>
        <span className="text-[#75757E] text-base max-3xl:text-sm max-xl:text-xs font-semibold flex items-center gap-1">
          {data?.products_count}
          <RiShareForwardLine className="text-color-primary flex items-center" />
        </span>
      </div>
    </div>
  );
};

export default CardInfoSalon;
